import { BLOCKED_ITEM_FORM_CONDITIONS } from '@exam-center/blocked-user-management';
import { z } from 'zod';

const BaseBlockedRecordExamPasserSchema = z.object({
  enforcementEnd: z
    .object({
      assign: z.union([z.literal('true'), z.literal('false')]).nullish(),
      date: z.date().nullish(),
    })
    .nullish(),
  remark: z
    .string()
    .max(BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH, {
      message: `ความยาวต้องไม่เกิน ${BLOCKED_ITEM_FORM_CONDITIONS.MAX_REASON_LENGTH} ตัวอักษร`,
    })
    .optional(),
});

export type BlockedRecordExamPasserFormType = z.infer<typeof BaseBlockedRecordExamPasserSchema>;

function validateEnforcementEnd(data: BlockedRecordExamPasserFormType, ctx: z.RefinementCtx) {
  const { enforcementEnd } = data;

  if (enforcementEnd?.assign === undefined || enforcementEnd?.assign === null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'กรุณากำหนดวันที่สิ้นสุดระงับสิทธิ์',
      path: ['enforcementEnd', 'assign'],
    });
    return;
  }

  if (enforcementEnd?.assign === 'true' && !enforcementEnd?.date) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'กรุณาเลือกวันที่สิ้นสุดระงับสิทธิ์',
      path: ['enforcementEnd', 'date'],
    });
    return;
  }
}

export const BlockedRecordExamPasserSchema = BaseBlockedRecordExamPasserSchema.superRefine(
  (data, ctx) => {
    validateEnforcementEnd(data, ctx);
  },
);
